<div class="clock-time-hour cyan font-14">
    {{posTimer.timeHour}}<span class="blink"><b>:</b></span>{{posTimer.timeMinute}}<sup class="time-meridian white">{{posTimer.timeMeridian}}</sup> <span [title]="posTimer.timeZone"
        class="white font-16 bold choppOff hw-timezone-cls ml-5">{{posTimer.timeZone}}</span>
</div>